/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BodyUpdateShowApiV1ShowsShowPut
 */
export interface BodyUpdateShowApiV1ShowsShowPut {
    /**
     * The title of the show.
     * @type {string}
     * @memberof BodyUpdateShowApiV1ShowsShowPut
     */
    title?: string;
    /**
     * The type of the show.
     * @type {string}
     * @memberof BodyUpdateShowApiV1ShowsShowPut
     */
    type?: string;
}

/**
 * Check if a given object implements the BodyUpdateShowApiV1ShowsShowPut interface.
 */
export function instanceOfBodyUpdateShowApiV1ShowsShowPut(value: object): boolean {
    return true;
}

export function BodyUpdateShowApiV1ShowsShowPutFromJSON(
    json: any,
): BodyUpdateShowApiV1ShowsShowPut {
    return BodyUpdateShowApiV1ShowsShowPutFromJSONTyped(json, false);
}

export function BodyUpdateShowApiV1ShowsShowPutFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): BodyUpdateShowApiV1ShowsShowPut {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'] == null ? undefined : json['title'],
        type: json['type'] == null ? undefined : json['type'],
    };
}

export function BodyUpdateShowApiV1ShowsShowPutToJSON(
    value?: BodyUpdateShowApiV1ShowsShowPut | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        type: value['type'],
    };
}
